import { forwardRef } from 'react';
import { classNames } from '../../utils/classNames';
import FormField from './FormField';

const Input = forwardRef(function Input(
  { id, label, hint, error, required, icon: Icon, endAdornment, className, inputClassName, ...props },
  ref
) {
  const describedBy = hint || error ? `${id}-description` : undefined;
  return (
    <FormField id={id} label={label} hint={hint} error={error} required={required} className={className}>
      <div className="relative">
        {Icon && <Icon className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-content-muted" aria-hidden="true" />}
        <input
          ref={ref}
          id={id}
          required={required}
          aria-invalid={Boolean(error)}
          aria-describedby={describedBy}
          className={classNames(
            'h-10 w-full rounded-control border bg-white px-3 text-sm text-content-primary shadow-xs outline-none transition placeholder:text-slate-400 focus:border-primary-500 focus:shadow-focus disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-content-muted',
            Icon && 'pl-9',
            endAdornment && 'pr-11',
            error && 'border-danger-500 focus:border-danger-500 focus:ring-danger-500/10',
            inputClassName
          )}
          {...props}
        />
        {endAdornment && (
          <div className="absolute right-1.5 top-1/2 -translate-y-1/2">
            {endAdornment}
          </div>
        )}
      </div>
    </FormField>
  );
});

export default Input;
